import { Link } from 'react-router-dom';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-primary-900 text-primary-50 mt-16">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 flex items-center justify-center">
                <i className="ri-film-line text-primary-900 text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold">李采潭电影</span>
            </div>
            <p className="text-sm text-primary-200/90 leading-relaxed max-w-md">
              汇聚李采潭主演及相关影视作品的资料与介绍，为影迷提供清晰、完整、易浏览的作品档案与剧情内容。
            </p>
            <p className="text-xs text-primary-300/70 mt-4 leading-relaxed max-w-md">
              本站内容与图片均为虚拟示例，仅用于展示用途，不含任何真实版权作品。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-accent-300 mb-4">浏览导航</h3>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/" className="text-primary-100 hover:text-accent-300 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category" className="text-primary-100 hover:text-accent-300 transition-colors cursor-pointer">电影分类</Link></li>
              <li><Link to="/search" className="text-primary-100 hover:text-accent-300 transition-colors cursor-pointer">搜索影片</Link></li>
              <li><Link to="/about" className="text-primary-100 hover:text-accent-300 transition-colors cursor-pointer">关于本站</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-accent-300 mb-4">联系与反馈</h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a href="mailto:hello@example.com" className="flex items-center gap-2 text-primary-100 hover:text-accent-300 transition-colors cursor-pointer">
                  <i className="ri-mail-line"></i>hello@example.com
                </a>
              </li>
              <li className="flex items-center gap-2 text-primary-100">
                <i className="ri-map-pin-line"></i>首尔 · 影视资料站
              </li>
              <li className="flex items-center gap-2 text-primary-100">
                <i className="ri-time-line"></i>内容每周更新
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 mt-10 pt-6 border-t border-primary-700/60 text-xs text-primary-200/80">
          <p>© {year} 李采潭电影 · 保留所有权利</p>
          <p>本站为虚构演示站点 · 无会员 / 播放 / 下载功能</p>
        </div>
      </div>
    </footer>
  );
}